import React from 'react';
import { Link } from 'react-router-dom';

const JoinUs: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Join the Choral Management Program
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-lg">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900">How It Works</h3>
              <p className="mt-2 text-sm text-gray-500">
                Welcome to our Choral Management Program! Here's how to join:
              </p>
              <ul className="mt-4 list-disc pl-5 text-sm text-gray-600 space-y-2">
                <li>Register for an account using your email address</li>
                <li>Select your school and role (typically "Student")</li>
                <li>Your registration will be reviewed by a teacher from your school</li>
                <li>Once approved, you'll receive full access to the platform</li>
              </ul>
            </div>

            <div className="flex items-center justify-between pt-6">
              <div className="text-sm">
                <p className="font-medium text-gray-600">
                  Ready to join?
                </p>
              </div>
              <div className="text-sm">
                <Link to="/register" className="rounded-md bg-blue-600 px-4 py-2 text-white font-medium hover:bg-blue-500">
                  Register Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUs;
